import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { CopyTextField } from "./AdminAPIKeyForm.styles";
import { FlexColumnDiv } from "./common.styles";
export const RevealContainer = styled(FlexColumnDiv) `
    gap: 16px;
    font-size: ${fontSizes.STANDARD};
`;
const bannerBase = css `
    display: flex;
    gap: 8px;
    align-items: flex-start;
    padding: 10px 12px;
    border-radius: 4px;
    line-height: 20px;
    color: ${colors.black};

    & > svg {
        flex-shrink: 0;
        margin-top: 1px;
        font-size: ${fontSizes.MEDIUM} !important;
    }
`;
export const SuccessBanner = styled.div `
    ${bannerBase}
    background-color: ${colors.forest_8};
    border: 1px solid ${colors.forest_30};

    & > svg {
        color: ${colors.forest_main};
    }
`;
export const WarningBanner = styled.div `
    ${bannerBase}
    background-color: ${colors.sunset_8};
    border: 1px solid ${colors.sunset_30};

    & > svg {
        color: ${colors.sunset_dark};
    }
`;
export const BannerStrong = styled.strong `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const FieldLabel = styled.div `
    font-weight: bold;
    margin-bottom: 6px;
`;
export const SecretField = styled(CopyTextField) `
    width: 100%;

    & input.Mui-disabled {
        font-family: monospace;
    }
`;
export const HelpText = styled.div `
    font-size: ${fontSizes.TINY};
    color: ${colors.black_lighter};
    margin-top: 6px;
`;
export const InlineCode = styled.code `
    font-family: monospace;
    font-size: ${fontSizes.TINY};
    background-color: ${colors.black_10};
    padding: 1px 5px;
    border-radius: 2px;
`;
export const RevealFooter = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;
